import { Box } from '@mui/material';
import { QuestionType } from '@/components/campaigns/CampaignQuestionsEditor/types';
import QuestionTypeChip from './QuestionTypeChip';

interface CallInsightFiltersProps {
    questionTypes: QuestionType[];
    selectedTypes: QuestionType[];
    onToggleFilter: (type: QuestionType) => void;
}

const CallInsightFilters: React.FC<CallInsightFiltersProps> = ({ questionTypes, selectedTypes, onToggleFilter }) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {questionTypes.map((type) => (
                <QuestionTypeChip key={type} type={type} isSelected={selectedTypes.includes(type)} onToggle={onToggleFilter} />
            ))}
        </Box>
    );
};

export default CallInsightFilters;
